import React from 'react';
import { JuniorHubScreen } from '../../components/home/JuniorHubScreen';
import { MINI_JUEGOS_ITEMS } from '../../lib/juniorTheme';

export default function MiniJuegosHubPage() {
  return (
    <JuniorHubScreen
      eyebrow="Mini juegos"
      title="Diversión musical"
      subtitle="Juegos cortos y coloridos para aprender jugando."
      emoji="🎮"
      accent="sun"
      items={MINI_JUEGOS_ITEMS}
    />
  );
}
